<template>
  <el-dialog class="demand_model_dialog" top="5vh" center :title="newTitle" width="80%" :before-close="handleClose"
    :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <el-form-item label="项目名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off" :disabled="isProjectDisabled">
        </el-input>
      </el-form-item>
      <div style="display:flex;">
        <el-form-item label="项目体系" prop="systemId" :label-width="formLabelWidth">
          <el-select  size="mini" :disabled="isProjectDisabled"  v-model="form.systemId"
            collapse-tags filterable placeholder="请选择项目体系" @change="getcooperateSystem">
            <el-option v-for="(key, value) in allSystem.ALLSYSTEMIDS" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="协同体系" prop="cooperateSystemIds" :label-width="formLabelWidth">
          <el-select size="mini" :disabled="isProjectDisabledWith" v-model="form.cooperateSystemIds"
                     collapse-tags multiple filterable placeholder="请选择协同体系">
            <el-option v-for="(key, value) in cooperateSystem" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目负责人" prop="ownerId" :label-width="formLabelWidth">
          <el-select size="mini" :disabled="isProjectDisabled"  v-model="form.ownerId" filterable
                     placeholder="请选择技术负责人">
            <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="立项日期" prop="approvalDate" :label-width="formLabelWidth">
          <el-date-picker :disabled="isProjectDisabled" value-format="yyyy-MM-dd"
                          v-model="form.approvalDate" type="date" placeholder="请选择时间" />
        </el-form-item>
        <el-form-item label="计划开始日期" prop="planStartDate" :label-width="formLabelWidth">
          <el-date-picker :disabled="isProjectDisabled" value-format="yyyy-MM-dd"
                          v-model="form.planStartDate" type="date" placeholder="请选择时间" />
        </el-form-item>
        <el-form-item v-if="isShowCompleteTime" label="计划完成日期" prop="planEndDate" :label-width="formLabelWidth">
          <el-date-picker :disabled="isProjectDisabled" value-format="yyyy-MM-dd"
                          v-model="form.planEndDate" type="date" placeholder="请选择时间" />
        </el-form-item>
      </div>
      <el-form-item label="状态" prop="" :label-width="formLabelWidth">
        <div>
          {{this.allStatusList.ALLSTATUSTYPE1[this.form.status]}}
        </div>
      </el-form-item>
      <el-form-item label="项目背景" prop="background" :label-width="formLabelWidth">
        <el-input type="textarea" :disabled="isProjectDisabled" :autosize="{ minRows: 6, maxRows: 16 }"
                  placeholder="请输入项目背景" v-model="form.background">
        </el-input>
      </el-form-item>
      <el-form-item label="项目目标" prop="target" :label-width="formLabelWidth">
        <el-input type="textarea" :disabled="isProjectDisabled" :autosize="{ minRows: 6, maxRows: 16 }"
        placeholder="请输入项目目标" v-model="form.target">
        </el-input>
      </el-form-item>
      <el-form-item label="项目价值评估" prop="evaluation" :label-width="formLabelWidth">
        <el-input type="textarea" :disabled="isProjectDisabled" :autosize="{ minRows: 6, maxRows: 16 }"
                  placeholder="请输入项目价值评估" v-model="form.evaluation">
        </el-input>
      </el-form-item>
      <el-form-item v-if="form.id && historylist.length" label="任务历史" :label-width="formLabelWidth">
        <TaskHistory :list="historylist" />
      </el-form-item>
      <el-form :model="form" v-if="form.id && step === 1">
        <el-form-item class="comment_warp" label="评论" :model="form" :label-width="formLabelWidth">
          <Comment  :id="form.id" :busiId="form.id"  type="1"/>
        </el-form-item>
      </el-form>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-show="isUpdata  && step === 1 && !isComplete && isReviewer && isShowEdit" type="warning" @click="changeStep(2)">编 辑</el-button>
      <el-button v-show="showSubmit" type="warning" :loading="loading.submit" @click="onSubmit">提 交</el-button>
      <el-button v-show="isPause && isUpdata && isReviewer && step === 1" type="warning" :loading="loading.restart" @click="onRestart">重 启</el-button>
      <el-button v-show="showRecord && isUpdata && isReviewer && step === 1" type="warning" @click="linkToModel ('','record',1)">记 录</el-button>
      <el-button v-show="!isComplete && showRecord && isUpdata && isReviewer && step === 1" type="warning" @click="dialogVisiblePStatus = true">变更状态</el-button>
      <el-button  type="success" @click="handleClose">取 消</el-button>
    </div>
    <el-dialog center :append-to-body="true" :title="newTitle" :visible.sync="dialogVisiblePStatus" width="40%">
      <el-form :model="pStatusForm" :rules="pStatusRules" ref="pStatusForm" >
        <el-form-item label="修改项目状态" prop="status" :label-width="formLabelWidth" >
          <el-select :style="iptStyle"  collapse-tags v-model="pStatusForm.status"
                     placeholder="请选择状态">
            <el-option label="暂停" value="3"></el-option>
            <el-option label="取消" value="4"></el-option>
            <el-option label="已完成" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="原因" prop="changeReason" :label-width="formLabelWidth" >
          <el-input type="textarea" rows="3" v-model="pStatusForm.changeReason" autocomplete="off" placeholder="项目状态变更原因" />
        </el-form-item>
        <el-form-item label=""  :label-width="formLabelWidth" >
          <el-button size="small" type="primary" @click="onChangePStatus">确 定</el-button>
          <el-button size="small" @click="dialogVisiblePStatus = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog center :append-to-body="true" :title="newTitle" :visible.sync="dialogVisibleReviwer" width="30%">
      <el-form :model="reviewerForm" >
        <el-form-item label="技术负责人" prop="reviewer" label-width="90px">
          <el-select size="mini" autocomplete="off" style="width:100%;" v-model="reviewerForm.reviewer" filterable
            placeholder="请选择技术负责人">
            <el-option v-for="(item, index) in reviewerSelect" :key="index" :label="item[0]" :value="item[1]">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  label-width="90px" >
          <el-button size="small" type="primary" :loading="reviewerForm.loading" @click="onChangeReviwer">确 定</el-button>
          <el-button size="small" @click="dialogVisibleReviwer = false">取 消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { Editor } from "@/components/index.js";
import Task from './task.vue'
import { formatEnToUtf8 } from "@/views/tops/devOps/components/util.js"
import Comment from '@/views/tops/devOps/producerSpace/components/project/comment.vue'
import {
  postDevOpsSpaceCreateProducerApi,
  postDevOpsSpaceUpdateProducerApi,
  postDevOpsSpaceDeleteProducerApi,
  getDevOpsSpaceProducerDetailApi,
  getDevOpsSpaceProducerListApi,
  postDevOpsSpaceDeleteTaskApi,
  postDevOpsSpaceCreateReviewerApi,
  postDevOpsSpaceUpdateReviewerApi,
  postDevOpsSpaceReviewerRollbackApi,
  postDevOpsSpaceUserPmEditStatusApi,
  postDevOpsSpaceUserPmEditReviewerApi,
  postDevOpsSpaceCreateProjectApi,
  getDevOpsSpaceFindOneProjectApi,
  postDevOpsSpaceEditProjectApi,
  postDevOpsSpaceUpdateProjectStatusApi, getDevOpsSpaceHistoryTaskListApi,
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {TaskHistory} from "@/views/tops/devOps/components/list";
export default {
  components: {TaskHistory, Editor, Comment, Task },
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    isShowCompleteTime:{
      type: Boolean,
      default: true,
    },
    tabid: {
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      form: {
        name: '',
        systemId: [],
        ownerId: '',
        approvalDate: '',
        planStartDate: '',
        planEndDate: '',
        background: '',
        target: '',
        evaluation:'',
        username:'',
        status:'0',
        createName:'',
        cooperateSystemIds: '',
      },
      pStatusForm:{
        status:'',
        changeReason:'',
        id: '',
        creator_user: '',
        isRestart: false,
      },
      reviewerForm:{
        reviewer:'',
        loading:false
      },
      pStatusRules:{
        status:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
        changeReason:{
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      rules: {
        name: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        systemId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        ownerId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        /*approvalDate: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        planStartDate: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        planEndDate: {
          required: true,
          message: "必填",
          trigger: "blur",
        },*/
      },
      formLabelWidth: '135px',
      loading: {
        dialog: false,
        submit: false,
        submitReviewed: false,
        submitRollBack:false,
        restart: false,
      },
      tasks: [],
      dialogVisibleTask: false,
      dialogVisiblePStatus:false,
      dialogVisibleReviwer: false,
      step: 1,
      formTaskInfo: {},
      reviewerSelect: [],
      showDetails: false,
        // 判断是否是产品
      isUserPm:false,
      historylist: [],
      systems: [],
      cooperateSystem:[],
      userId:'',
      username: '',
    };
  },
  async mounted() {
    await this.$store.dispatch('getDevopsSystem')
    const { id = '', projectName = '',next = false } = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.username = username;
    this.form = { ...this.form, id, projectName, createName: username}
    this.$set(this.form, 'username', username)
    this.pStatusForm.creator_user = username;
    if (this.isUpdata) {
      await this.init(id);
      if(this.showEdit && next){
        this.step = 2;
      }
      await this.getHistoryList();
      if(this.form.systemId){
        const systemId = this.form.systemId;
        let data = this.allSystem.NEWALLSYSTEMIDS;
        let newarr = {};
        data.forEach((item,index)=>{
          if(item && systemId != index){
            newarr[index] = item
          }
        })
        this.cooperateSystem = newarr;
      }
    } else {
      if(this.$store.state.devOps.userInfo.userId){
        let defauleOwnerId = this.$store.state.devOps.userInfo.userId;
        this.form.ownerId = defauleOwnerId.toString();
      }
      this.step = 2;
      this.$set(this.form, 'user_pm', username)
    }
    if(this.$store.state.devOps.userInfo.userId){
      this.userId = this.$store.state.devOps.userInfo.userId;
    }
  },
  computed: {
    ...mapState(
      {
        allSelect: (state) => state.devOps.ALLSELECT,
        allSystem: (state) => state.devOps.ALLSYSTEM,
        allUserList: (state) => state.devOps.ALLUSERLIST,
        allStatusList: (state) => state.devOps.ALLSTATUSLIST,
      }
    ),
    newTitle() {
      if (this.isUpdata) {
        return '['+ this.form.id + '] 项目-' + this.form.name;
      } else {
        return '新建项目'
      }
    },
    // 判断需求状态
    isPStatus() {
      const { p_status } = this.form;
      if(p_status === 'p_stop' || p_status === 'p_canceled') return false;
      return true
    },
    // 判断是否是技术负责人
    isReviewer() {
      if(this.isAdmin || this.isReviewerLeader) return true;
      if(this.form.owner){
        return this.form.username === this.form.owner.nameEn;
      }
      return false;
    },
    isAdmin(){
      if(this.username){
        if(this.allUserList.ALLUSERTYPE13 && this.allUserList.ALLUSERTYPE13[this.username]) return true
      }
      return false;
    },
    isReviewerLeader(){
      if(this.userId && this.form.owner){
        const reviewerId = this.form.owner.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[reviewerId]){
          return this.allUserList.LEADERUSER[reviewerId] === this.userId ;
        }
      }
      return false;
    },
    // 判断是否是新建
    isUpdata() {
      return this.form.id;
    },
    isCreator(){
      if(this.form.create){
        return this.form.create.nameEn === this.form.username;
      }
      return false;
    },
    isPause(){
      return this.form.status === '3';
    },
    isComplete(){
      return this.form.status === '2';
    },
    //待开始 进行中
    isShowEdit(){
      return this.form.status === '0' || this.form.status === '1';
    },
    showRecord(){
      return this.form.status === '0' || this.form.status === '1';
    },
    // 需求部分不可编辑
    isProjectDisabled() {
      //  方案状态  开发团队 项目体系 需求描述 PRD链接 需求人员 产品人员 技术负责人 优先级 期望上线日期 --- 创建需求可编辑  未评审需根据step判断 评审中不可编辑 已评审不可编辑
      if (this.isUpdata) { // 如果是更新页面
        if (this.step === 1) return true;
      }
      return false; // 默认可编辑
    },
    isProjectDisabledWith(){
      if (this.isUpdata) { // 如果是更新页面
        if (this.step === 1) return true;
      }
      if(!this.form.systemId){
        return true;
      }
      return false // 默认可编辑
    },

    // 展示技术负责人部分的表单
    showReviewedForm() {
      if (this.isUnderReview) { // 评审中
        return true
      }
      if (this.isReviewed) { // 已评审
        return true
      }
      return false
    },
    // 判断技术负责人部分是否可编辑
    isReviewedDisabled() {
      const { username, reviewer } = this.form;
      if (this.isAdmin) return false;
      if (username === reviewer) return false;  // 技术负责人展示
      return true
    },
    // 判断是否展示任务添加
    showTaskAdd() {
      const { p_status, username, reviewer } = this.form;
      if ((this.isReviewed || this.isHistoryReviewed) && p_status !== 'p_notstart' && p_status !== 'p_indesign') {
        if (this.isAdmin) return true; // 管理元展示
        if (username === reviewer) return true;  // 技术负责人展示
      }
      return false;
    },
    // 判断是否展示任务列表
    showTaskList() {
      return (this.isReviewed || this.isHistoryReviewed) && this.tasks.length;
    },
    // 判断任务部分是否可编辑
    isTaskDisabled() {
      const { username, reviewer } = this.form;
      if (!this.isHistoryReviewed && !this.isReviewed) return true;
      if (this.isAdmin) return false; // 管理元展示
      if (username === reviewer) return false;  // 技术负责人展示
      return true;
    },
    //参会人员中文
    participantsStrEn() {
      let str = ''
      this.form.participants.forEach(item => {
        str += this.allSelect.TEXTUSERSEN[item] + ' '
      })
      return str;
    },
    // 是否是历史需求已评审
    isHistoryReviewed() {
      return this.form.reviewed_status === 'history_reviewed'
    },
    // 判断是否是评审中 not_reviewed under_review reviewed history_reviewed
    isUnderReview() {
      return this.form.reviewed_status === 'under_review'
    },
    // 判断是否是未评审
    isNotReviewed() {
      return this.form.reviewed_status === 'not_reviewed'
    },
    // 判断是否是已评审
    isReviewed() {
      return this.form.reviewed_status === 'reviewed'
    },
    showEdit() {
      if (this.isNotReviewed) {//未评审 非管理员 非产品人员
        if (this.isAdmin) {
          return this.step === 1
        }
        if (this.form.username === this.form.user_pm) {
          return this.step === 1
        }
      }
      if (this.isUnderReview) {
        return false
      }
      if (this.isReviewed) { // 已完成 非管理员 非技术负责人
        if (this.isAdmin) {
          return this.step === 1
        }
        if (this.form.username === this.form.reviewer) {
          return this.step === 1
        }
      }
      if (this.isHistoryReviewed) {
        return false;
      }
      return false;
    },
    showSubmit() {
      return this.step === 2 || !this.isUpdata;
    },
    TEXTREVIEWSTATUS() {
      return this.form.reviewed_status && this.allSelect.TEXTREVIEWSTATUS && this.allSelect.TEXTREVIEWSTATUS[this.form.reviewed_status]
    }
  },
  methods: {
    openDialogVisibleReviwer(){
      this.reviewerForm.reviewer = this.form.reviewer
      this.dialogVisibleReviwer = true
    },
    async getHistoryList(){
      await getDevOpsSpaceHistoryTaskListApi({type:1,busiId: this.form.id}).then((res)=>{
        this.historylist = res.data;
      });
    },
    // 变更技术负责人
    async onChangeReviwer(){
      try {
        this.reviewerForm.loading = true;
        const ret = await postDevOpsSpaceUserPmEditReviewerApi({id:this.form.id,user_pm:this.form.user_pm,reviewer:this.reviewerForm.reviewer})
        if(ret.status === 'success'){
          this.$notify({
            message: ret.data.msg || "变更成功",
            type: "success",
          })
          this.dialogVisibleReviwer = false;
          this.hideDialogVisible()
        }else{
          this.$notify({
            message: ret.data.msg || "变更失败",
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error,
          type: "error",
        })
      }finally {
        this.reviewerForm.loading = false;
      }
    },
    // 变更需求状态
      onChangePStatus(){
        this.$refs["pStatusForm"].validate(async (valid) => {
          if (valid) {
            this.queryChangePStatus()
          }
        })
      },
      async queryChangePStatus(back_status){
        try {
          let params =  { ...this.pStatusForm ,status:Number(this.pStatusForm.status), id: Number(this.form.id)}
          const ret = await postDevOpsSpaceUpdateProjectStatusApi(params)
          if(ret.status === 'success'){
            this.dialogVisiblePStatus = false;
            this.$notify({
              message: ret.message || "变更成功",
              type: "success",
            })
            this.hideDialogVisible()
          }else{
            this.$notify({
              message: ret.message || "变更失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "变更失败",
            type: "error",
          })
        }
    },
    // 评审中 技术负责人回退
    onRollback(){
        this.$confirm('此操作将回退到上一步, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true,
            type: 'warning'
          }).then(async () => {
            try {
              this.$set(this.loading, 'submitRollBack', true)
              const ret = await postDevOpsSpaceReviewerRollbackApi({id:this.form.id})
              if (ret.status === 'success') {
                this.$notify({
                  message: '回退成功',
                  type: "success",
                })
                setTimeout(() => {
                  this.handleClose()
                }, 500)
              } else {
                this.$notify({
                  message: ret.data.msg || "回退失败",
                  type: "error",
                })
              }
            } catch (error) {
              this.$notify({
                message: error || "网络错误",
                type: "error",
              })
            } finally {
              this.loading.submitRollBack = false;
            }
          })
    },
    changeProjectSystem(val) {
      this.form.systemId = val;
      this.form.reviewer = ''
      try {
        const list = this.allSelect?.TEXTECHNICALREVIEW[val] || [];
        if (list && list.length) {
          this.$set(this.form, 'reviewer', list[0][1])
        }
        this.reviewerSelect = list;
      } catch (error) { }
    },
    changeStep() {
      this.step = 2;
    },
    async getcooperateSystem(val){
      this.form.cooperateSystemIds = [];
      this.form. cooperateSystemIds = [];
      this.form.cooperateSystemIds = [];
      let data = this.allSystem.NEWALLSYSTEMIDS;
      let newarr = {};
      data.forEach((item,index)=>{
         if(item && val != index){
           newarr[index] = item
         }
      })
      //delete data[val]
     this.cooperateSystem = newarr;
    },
    // 获取需求详情
    async init(id) {
      this.loading.dialog = true
      try {
        const ret = await getDevOpsSpaceFindOneProjectApi({ id:id });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
          systemId: info.projectSystemId,
          planEndDate: info.palnEndDate,
          ownerId: info.owner.id ? info.owner.id.toString():'',
          cooperateSystemIds: info.cooperateSystemIds ? info.cooperateSystemIds.split(",") : [],
        };
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }
    },
    // 添加任务
    onAddTask(type, row) {
      const {is_admin,reviewer,reviewed_status,id,title,user_pm,link_to,re_details,p_link} = this.form;
      if (type === 'add') {
        this.formTaskInfo = { is_admin, reviewer,user_pm, reviewed_status, link_to: this.formatLink(link_to),re_details,p_link: this.formatLink(p_link),taskInfo: { pid: id, title } }
      }
      if (type === 'copy') {
        this.formTaskInfo = {
          ...this.form,
          link_to: this.formatLink(link_to),
          p_link: this.formatLink(p_link),
          taskInfo: {
            ...row,
            pid: id,
            user_pm,
            openType: 'copy'
          }
        }
      }
      this.dialogVisibleTask = true;
    },
    // 链接判断
    formatLink(val){
      if(!val) return '';
      return val.startsWith('http') ? val :`http://${val}`
    },
    // 技术负责人提交
    async onSubmitReviewed(action) {
      console.log(this.form);
      return false;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if (this.form.p_status !== 'p_finish') {
            this.$notify({
              message: '请将方案状态修改到已完成',
              type: "warning",
            })
            return
          }
          this.$confirm('此操作将进行到下一步, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true,
            type: 'warning'
          }).then(async () => {
            try {
              this.$set(this.loading, 'submitReviewed', true)
              if (this.step === 2 && action === 'create') {
                await this.onSubmit(false)
              }
              const {
                id = "",
                reviewer = '',
                user_pm = '',
                technical_difficulty = '',
                participants = '',
                link_to = '',
                re_details = '',
                p_link = ''
              } = this.form;
              const param = { id, reviewer, user_pm};
              const ret = action === 'create' ? await postDevOpsSpaceCreateReviewerApi({...param, p_link:this.formatLink(p_link)}) : await postDevOpsSpaceUpdateReviewerApi({ ...param, technical_difficulty, participants: String(participants), re_details,link_to:this.formatLink(link_to),  })
              if (ret.status === 'success') {
                this.$notify({
                  message: '提交成功',
                  type: "success",
                })
                setTimeout(() => {
                  this.handleClose()
                }, 500)
              } else {
                this.$notify({
                  message: ret.data.msg || "提交失败",
                  type: "error",
                })
              }
            } catch (error) {
              this.$notify({
                message: error || "网络错误",
                type: "error",
              })
            } finally {
              this.loading.submitReviewed = false;
            }
          })
        }
      })
    },
    // 需求提交
    async onSubmit(close = true) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.moduleSubmit(close)
        }
      });
    },
    // 确定并提交技术评审
    async onConfirmSubmitReviewed(close = true) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if(!this.form.p_link){
            this.$notify({
              message: "PRD链接必填",
              type: "warning",
            });
            return ;
          }
          if (this.form.p_status !== 'p_finish') {
            this.$notify({
              message: '请将方案状态修改到已完成',
              type: "warning",
            })
            return
          }
          const {
            title = "",
            details = "",
            demander = [],
            user_pm = [],
            plt = "",
            priority = "",
            tag = [],
            p_status = "",
            p_link = '',
            p_category = [],
            systemId = [],
            reviewer = '',
            link_to = '',
            re_details = '',
            technical_difficulty = '',
            participants = [],
            reviewed_status = ''
          } = this.form;
          const param = { title, details, demander: demander.toString(), user_pm: user_pm.toString(), p_category: p_category.toString(), systemId: systemId.toString(), project_status: p_status, priority, tag: tag.toString(), reviewer, plt, p_link: this.formatLink(p_link) };
          // 创建
          const ret = await postDevOpsSpaceCreateProducerApi(param);
          if (ret.status === 'success') {
            if(ret.data){
              const {id = ""} = ret.data;
              const r_params = {
                id: id,
                reviewer: reviewer,
                user_pm: user_pm
              }
              const result = await postDevOpsSpaceCreateReviewerApi({...r_params, p_link:this.formatLink(p_link)})
              if(result.status === 'success'){
                this.$notify({
                  message: '提交成功',
                  type: "success",
                })
                setTimeout(() => {
                  this.handleClose()
                }, 500)
              }else{
                this.$notify({
                  message: result.data.msg || "提交失败",
                  type: "error",
                })
                this.handleClose()
              }
            }

          }else {
            this.$notify({
              message: ret?.data?.msg || "失败",
              type: "error",
            })
          }
          //this.moduleSubmit(close)
        }
      });
    },
    // 调用需求提交接口
    async moduleSubmit(close = true){
      try {
            close && this.$set(this.loading, 'submit', true)
            const param = this.form;
            // id 存在 更新 不存在 创建
            const ret = this.isUpdata ? await postDevOpsSpaceEditProjectApi({...param,id: this.form.id,cooperateSystemIds: this.form.cooperateSystemIds.toString()}) : await postDevOpsSpaceCreateProjectApi({...param,cooperateSystemIds:this.form.cooperateSystemIds.toString()});
            if (ret.status === 'success') {
              if (close) {
                this.$notify({
                  message: '提交成功',
                  type: "success",
                })
                setTimeout(() => {
                  if(this.form.reviewed_status === 'under_review') {
                    this.handleClose('demand')
                  }else{
                    this.handleClose()
                  }
                }, 500)
              }
            } else {
              this.$notify({
                message: ret?.data || "失败",
                type: "error",
              })
            }
          } catch (error) {
            this.$notify({
              message: error || "网络错误",
              type: "error",
            })
          } finally {
            this.loading.submit = false;
          }
    },
    // 重启
    onRestart() {
      this.$confirm("是否重启该项目?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'restart', true)
        try {
          const res = await postDevOpsSpaceUpdateProjectStatusApi({
            id: this.form.id,
            changeReason: '重启项目',
            status: 1,
            isRestart: true,
          })
          if (res.status === "success") {
            this.$notify({
              message: res.message || '重启成功',
              type: "success",
            })
            this.handleClose();
          } else {
            this.$notify({
              message: res.message || "重启失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "网络错误",
            type: "error",
          })
        } finally {
          this.loading.restart = false;
        }
      });
    },
    // 修复 input 框输入 乱聚焦到富文本的问题
    focusLinkFn(refName) {
      setTimeout(() => {
        this.$refs[refName].focus()
      })
    },
    // 跳转外链
    linkFn(url) {
      window.open(url)
    },
    // 打开新的模块
    linkToModel(row, type, back='') {
      // if (type !== 'task') return;
      let newRow = {
        ...this.form,
      }
      this.showDialogVisible(type, newRow, back)
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    // 修改富文本内容
    changeContent(val) {
      this.form.details = val;
    },
    // 删除任务
    onDeleteTask(row) {
      this.$confirm("此操作将删除该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'task' + row.id, true)
        try {
          const res = await postDevOpsSpaceDeleteTaskApi({
            id: row.id,
          });
          if (res.status === "success") {
            this.queryTaskList(this.form.id)
          } else {
            this.$notify({
              message: res?.data?.msg || "删除失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          })
        } finally {
          this.loading['task' + row.id] = false;
        }
      });
    },
    // 关闭任务弹窗
    handleTaskClose() {
      this.dialogVisibleTask = false;
      this.queryTaskList(this.form.id)
    },
    // 任务列表 需求进度 需求状态
    async queryTaskList(id) {
      try {
        const res = await getDevOpsSpaceProducerListApi({ title: id });
        this.tasks = res?.data[0]?.tasks || []
        this.form.p_issue_status = res?.data[0]?.p_issue_status || ''
      } catch (error) {
        console.error(error)
      }

    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
  }
};
</script>
<style lang="scss">
.demand_model_dialog {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
}

.popperDom {
  max-width: 240px;
}
</style>
